import { Add, Close, Delete } from "@mui/icons-material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";

import React, { memo, useRef, useState } from "react";
import { BIGrey } from "../../../../assets/helpers";
import PictureViewer from "../../../../common/PictureViewer";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";
import { useSelector } from "react-redux";
import { ClientTimesheetUDFieldComponent } from "../../shared/components/TimesheetUDFields";

export const JobsListingManual = memo(
  ({
    index,
    item,
    CLIENT_COLOR,
    handelDelete,
    handelExpand,
    handelAddImage,
    handelImageRemove,
    handelFieldsChange,
    handelTimeChange,
    handleBlurMileage,
    handelMileageChange,
    handelMilageUnitChange,
    handelJobsUdFieldChange,
    handelActivityUdFieldChange
  }) => {
    const inputRef = useRef();
    const handelInputClick = () => {
      if (inputRef?.current) {
        inputRef.current?.click();
      }
    };
    const { multiLanguageData } = useSelector((state) => state?.main);
    const { TEXT_HOURS, TEXT_MILEAGE, TEXT_DETAIL_MODAL_KM, TEXT_MI, TEXT_WRITE_SOMETHING } =
      ClientEnglishFallback?.JobsListingManual(multiLanguageData?.JobsListingManual || {});

    return (
      <div
        style={{
          borderRadius: "10px",
          cursor: "pointer",
          backgroundColor: "white"
        }}>
        <Grid
          size={12}
          spacing={1}
          sx={{
            borderRadius: "10px ",
            padding: "10px",
            bgcolor: "white"
          }}
          container
          key={index}
          style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid size={12}>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} width={"100%"}>
              <Stack justifyItems={"center"}>
                <Typography
                  sx={{
                    wordBreak: "break-all",
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                    fontSize: "17px",
                    fontWeight: "bold"
                  }}>
                  {`${item?.clientJobCode} - ${item?.clientJobName}`}
                </Typography>
                {item?.activityId && (
                  <Typography
                    sx={{
                      wordBreak: "break-all",
                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                      color: BIGrey
                    }}>
                    {item?.labourActivityCode} -{item?.labourActivityName}
                  </Typography>
                )}
              </Stack>
              <Stack sx={{ gap: 1 }}  direction={"row"}>
                <IconButton
                  onClick={() => {
                    handelDelete(index, item);
                  }}
                  size="small">
                  <Delete
                    sx={{
                      color: CLIENT_COLOR
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => {
                    handelExpand(index);
                  }}
                  size="small">
                  {item?.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Stack>
            </Stack>
          </Grid>

          <Grid spacing={1} container size={12}>
            <Grid size={3}>
              <Stack>
                <Typography
                  sx={{
                    wordBreak: "break-all",
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1
                  }}>
                  {TEXT_HOURS}
                </Typography>

                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <Select
                    size="small"
                    value={typeof item?.hours === 'string' && item?.hours.includes(':') ? Number(item.hours.split(':')[0]) : (typeof item?.hours === 'number' ? item.hours : "")}
                    onChange={(e) => {
                      const h = Number(e.target.value);
                      const m = typeof item?.hours === 'string' && item?.hours.includes(':') ? Number(item.hours.split(':')[1]) : item?.minutes ?? 0;
                      handelTimeChange(h, m, index);
                    }}
                    sx={{
                      backgroundColor: '#e4e4e4',
                      borderRadius: '8px',
                      minWidth: 72,
                      '& .MuiSelect-select': { padding: '2px 6px', height: '26px', display: 'flex', alignItems: 'center', fontSize: '13px' },
                      '& .MuiMenuItem-root': { paddingTop: '4px', paddingBottom: '4px', minHeight: 28 },
                      '& fieldset': { border: 'none' }
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: "180px !important",
                          overflowY: "auto !important"
                        }
                      },
                      slotProps: {
                        paper: {
                          sx: {
                            maxHeight: "180px !important",
                            overflowY: "auto !important"
                          }
                        }
                      }
                    }}
                  >
                    <MenuItem value="" sx={{ padding: '4px 6px' }}>--</MenuItem>
                    {Array.from({ length: 25 }, (_, i) => (
                      <MenuItem key={i} value={i} sx={{ padding: '4px 6px', minHeight: 28 }}>{i}</MenuItem>
                    ))}
                  </Select>

                  <Select
                    size="small"
                    value={typeof item?.hours === 'string' && item?.hours.includes(':') ? Number(item.hours.split(':')[1]) : (item?.minutes ?? 0)}
                    onChange={(e) => {
                      const m = Number(e.target.value);
                      const h = typeof item?.hours === 'string' && item?.hours.includes(':') ? Number(item.hours.split(':')[0]) : item?.hours ?? 0;
                      handelTimeChange(h, m, index);
                    }}
                    sx={{
                      backgroundColor: '#e4e4e4',
                      borderRadius: '8px',
                      minWidth: 86,
                      '& .MuiSelect-select': { padding: '2px 6px', height: '26px', display: 'flex', alignItems: 'center', fontSize: '13px' },
                      '& .MuiMenuItem-root': { paddingTop: '4px', paddingBottom: '4px', minHeight: 28 },
                      '& fieldset': { border: 'none' }
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: "180px !important",
                          overflowY: "auto !important"
                        }
                      },
                      slotProps: {
                        paper: {
                          sx: {
                            maxHeight: "180px !important",
                            overflowY: "auto !important"
                          }
                        }
                      }
                    }}
                  >
                    {Array.from({ length: 60 }, (_, i) => (
                      <MenuItem key={i} value={i} sx={{ padding: '4px 6px', minHeight: 28 }}>{i < 10 ? `0${i}` : i}</MenuItem>
                    ))}
                  </Select>
                </div>
                {/* <TextField  
                
                  onBlur={() => {
                    handleBlurHour(index);
                  }}
                  value={item?.hours}
                  placeholder="--:--"
                  size="small"
                  sx={{
                    textAlign: "center",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    },
                    "& .MuiInputBase-input": {
                      textAlign: "center" // Center typed text
                    },
                    "& .MuiInputBase-input::placeholder": {
                      textAlign: "center" // Center placeholder
                    },
                    background: "#e4e4e4",
                    borderRadius: "8px"
                  }}
                  textAlign={"center"}
                /> */}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        {item?.expanded && (
          <Grid
            spacing={1}
            container
            size={12}
            style={{
              padding: "10px",
              backgroundColor: "#FBFBFA",
              borderRadius: "0px 0px 10px 10px",

              width: "100%"
            }}>
            <Grid sx={{ gap: 1 }} size={12}  container>
              <Grid size={5}>
                <Stack>
                  <Typography>{TEXT_MILEAGE}</Typography>
                  <TextField
                    onBlur={() => {
                      handleBlurMileage(index);
                    }}
                    onChange={(e) => {
                      handelMileageChange(e.target.value, index);
                    }}
                    value={item?.mileage}
                    size="small"
                    type="number"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0"
                        // padding: " 5px 10px"
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        border: "none"
                      },
                      background: "#e4e4e4",
                      borderRadius: "10px"
                    }}
                    placeholder="0.0"
                    fullWidth
                  />
                </Stack>
              </Grid>
              <Grid sx={{alignSelf:'end'}} size={5}>
                <Select
                  size="small"
                  fullWidth
                  value={item?.mileageUnit}
                  onChange={(e) => {
                    handelMilageUnitChange(e.target.value, index, "mileageUnit");
                  }}
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  sx={{
                    "& fieldset": { border: "none" }
                  }}>
                  <MenuItem value={"km"}>{TEXT_DETAIL_MODAL_KM}</MenuItem>
                  <MenuItem value={"mi"}>{TEXT_MI}</MenuItem>
                </Select>
              </Grid>
              <Grid size={12}>
                <TextField
                  fullWidth
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0",
                      padding: " 5px 10px"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  rows={5}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    handelFieldsChange(inputValue, index, "notes");
                  }}
                  value={item.notes}
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  placeholder={TEXT_WRITE_SOMETHING}
                />
              </Grid>
            </Grid>

            <Grid size={12}>
              <Stack
                sx={{
                  scrollbarWidth: "none",
                  width: "100%",
                  overflowX: "auto"
                }}
                direction={"row"}
                spacing={1}>
                <input
                  onChange={(e) => handelAddImage(e, index)}
                  type="file"
                  ref={inputRef}
                  hidden
                  accept="image/*"
                  multiple
                />
                <div
                  onClick={handelInputClick}
                  style={{
                    margin: "0px",
                    border: "1px solid #e4e4e4",
                    borderRadius: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    height: "100px",
                    width: "100px",
                    minWidth: "100px"
                  }}>
                  <Add />
                </div>
                <ImageComponent
                  item={item?.pictureList}
                  handelImageRemove={handelImageRemove}
                  jobIndex={index}
                />
              </Stack>
            </Grid>
            {item?.clientActivitiesUDFieldsList?.length > 0 && (
              <Grid size={12}>
                <ClientTimesheetUDFieldComponent
                  udFields={item?.clientActivitiesUDFieldsList}
                  onChange={handelActivityUdFieldChange}
                  index={index}
                />
              </Grid>
            )}
            {item?.clientJobUDFieldsList?.length > 0 && (
              <Grid size={12}>
                <ClientTimesheetUDFieldComponent
                  udFields={item?.clientJobUDFieldsList}
                  onChange={handelJobsUdFieldChange}
                  index={index}
                />
              </Grid>
            )}
          </Grid>
        )}
      </div>
    );
  }
);

export const ImageComponent = memo(({ item, handelImageRemove, jobIndex }) => {
  const [imagePreview, setImagePreview] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const handelPreview = () => {
    setImagePreview(true);
  };
  const createObjectURL = (file) => {
    try {
      return URL.createObjectURL(file);
    } catch (e) {
      console.log('createObjectURL-> Error When Creating Object URL: ',e);
      return file;
    }
  };
  return (
    <>
      <PictureViewer
        isOpen={imagePreview}
        onClose={() => setImagePreview(false)}
        pictures={item?.map((pic) => ({
          src: pic.src || createObjectURL(pic.file),
          alt: ""
        }))}
        viewerIndex={imageIndex}
      />
      {item?.map((file, i) => {
        return (
          <div
            style={{
              position: "relative"
            }}>
            <Close
              onClick={() => {
                handelImageRemove(i, jobIndex, file);
              }}
              sx={{
                background: "white",
                borderRadius: "20px",
                position: "absolute",
                right: "0px",
                top: "2px",
                color: "red"
              }}
            />
            <img
              onClick={() => {
                setImageIndex(i);
                handelPreview();
              }}
              style={{
                height: "100px",
                minWidth: "100px",
                maxWidth: "100px",
                cursor: "pointer",
                borderRadius: "10px",
                objectFit: "cover"
              }}
              src={file?.thumbFileUrl || createObjectURL(file?.file)}
              alt=""
            />
          </div>
        );
      })}
    </>
  );
});

